<template>
  <auth-page>
    <logo/>
    <h5 class="text-center">INTERACTIVE INFORMATION PLATFORM</h5>
    <b-card class="text-center bg-light mb-3">
      <b-card-title class="text-center">
        <h5>LOGIN</h5>
      </b-card-title>
      <b-card-body>
        <b-form @submit="onSubmit">
          <b-form-group>
            <label class="sr-only" for="email-input">Email</label>
            <input
              id="email-input"
              :disabled="saving"
              :value="fields.email"
              class="form-control"
              placeholder="email"
              @input="setEmail">
            <validation-errors :validation-errors="apiErrors.email"/>
          </b-form-group>
          <b-form-group>
            <label class="sr-only" for="password-input">Password</label>
            <input
              id="password-input"
              :disabled="saving"
              :value="fields.password"
              type="password"
              class="form-control"
              placeholder="password"
              @input="setPassword">
            <validation-errors :validation-errors="apiErrors.password"/>
          </b-form-group>
          <b-form-group>
            <b-button :disabled="saving" type="submit" block variant="dark">
              Log In
              <span v-if="saving"><i class="fas fa-spinner fa-spin"></i></span>
            </b-button>
          </b-form-group>
          <b-form-group>
            <div class="link-wrapper">
              <router-link :to="{name: 'forgot-password', query: {email: fields.email}}" class="link-light">
                Reset your password
              </router-link>
              &nbsp;
              &nbsp;
              <router-link :to="{name: 'sign-up'}" class="link-light">Sign up for an account</router-link>
            </div>
          </b-form-group>
          <form-fail :form-errors="apiErrors.other"/>
        </b-form>
      </b-card-body>
    </b-card>
  </auth-page>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import authPage from '../../templates/auth-page'
import validationErrors from '../../common/form/validation-errors'
import formFail from '../../common/form/form-fail'
import logo from '../../common/logo'

export default {
  components: {
    authPage,
    validationErrors,
    formFail,
    logo
  },
  computed: {
    ...mapState('token/forms/login', [
      'apiErrors',
      'fields',
      'password',
      'saving'
    ])
  },
  created () {
    if (this.$route.query.email) {
      this.$store.commit('token/forms/login/setField', {
        field: 'email',
        value: this.$route.query.email
      })
    }
  },
  methods: {
    ...mapActions({
      login: 'token/login'
    }),
    onSubmit (e) {
      e.preventDefault()
      this.login()
    },
    setEmail (e) {
      this.$store.commit('token/forms/login/setField', {
        field: 'email',
        value: e.target.value
      })
    },
    setPassword (e) {
      this.$store.commit('token/forms/login/setField', {
        field: 'password',
        value: e.target.value
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.link-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/auth/login.vue